module.exports = __webpack_public_path__ + "static/media/CanauxAlertes.78dc644b.png";